import gql from 'graphql-tag';

export default gql`
  fragment VoucherPaymentFragment on VoucherPayment {
    id
    type
    firstName
    lastName
    email
    expiryDate
  }
`;
